﻿import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import Accessibility from 'highcharts/modules/accessibility';

const _hcRenders = {
	priceHistoryTooltipETF: ({ x, point }) => (`<div>
            <div>As of ${Highcharts.dateFormat('%Y/%m/%d', new Date(x))}</div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Market Price:</div>
                <div>$${Highcharts.numberFormat(point.market_price, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Asset Value:</div>
                <div>$${Highcharts.numberFormat(point.net_asset_value, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Bid/Ask Midpoint:</div>
                <div>$${Highcharts.numberFormat(point.bid_ask_midpoint, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Volume:</div>
                <div>${Highcharts.numberFormat(point.volume, -1, null, ',')}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Assets:</div>
                <div>$${Highcharts.numberFormat(point.net_assets, 0, null, ',')}</div>
            </div>
        </div>`
	),
	bidAskPremiumTooltip: ({ y, x }) => (`<div>
            <div><strong>${y < 0 ? 'Discount' : 'Premium'}</strong></div>
            <div>
                ${Highcharts.dateFormat('%Y/%m/%d', new Date(x))} : ${Highcharts.numberFormat(y, 2)}%
            </div>
        </div>`),
	targetOutcomeNoCapChartToolTip: ({ point, series, x, y }) => {

		var asOfDateTime = point.prc_type == 'Intraday' ? ` at ${Highcharts.dateFormat('%l:%M %p', point.time_stamp)} ET` : '';

		return `
            <div style="text-align: left;">As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}${asOfDateTime}</div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label"><strong>Fund</strong> Total Return:</div>
                <div>${Highcharts.numberFormat(point.fnd_total_rtn, 2)}%</div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label"><strong>Fund</strong> Value/Return:</div>
                <div>$${Highcharts.numberFormat(point.fnd_value, 2)}/${Highcharts.numberFormat(point.fnd_price_rtn, 2)}%</div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label"><strong>${series.chart.series[2].name}</strong> Value/Return:</div>
                <div>$${Highcharts.numberFormat(point.asst_value, 2)}/${Highcharts.numberFormat(point.asst_ret, 2)}%</div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label">Remaining Outcome Period:</div>
                <div>${point.rmg_outcome} days</div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label">Paid/Remaining Distribution:</div>
                <div>$${Highcharts.numberFormat(point.paid_distribution_amt, 4)}/$${Highcharts.numberFormat(point.remaining_distribution_amt, 4)} </div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label">Max Remaining Total Return (Net):</div>
                <div>${point.remaining_total_return_amt}% (${point.remaining_total_return_net_amt}%)</div>
            </div>
            <div class="chartTooltipLine">
                    <div class="chartTooltipLine--label">Remaining Buffer (Net):</div>
                    <div>${Highcharts.numberFormat(point.rmg_buffer, 2)}% (${Highcharts.numberFormat(point.rmg_buffer_net, 2)}%)</div>
            </div>
            <div class="chartTooltipLine">
                  <div class="chartTooltipLine--label">Reference Asset To Buffer End:</div>
                  <div>${Highcharts.numberFormat(point.asst_buffer_end, 2)}%</div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label">Unrealized Option Payoff (Net):</div>
                <div>${Highcharts.numberFormat(point.unrealized_option_payoff, 2)}% (${Highcharts.numberFormat(point.unrealized_option_payoff_net, 2)}%)</div>
            </div>
        `;
	},
	targetOutcomeChartTooltip: ({ point, series, x, y }, showCap, showBuffer) => {

		var asOfDateTime = point.prc_type == 'Intraday' ? ` at ${Highcharts.dateFormat('%l:%M %p', point.time_stamp)} ET` : '';

		// Only show Remaining Cap information in the chart tool tip if Cap information exists(i.e.this is NOT an Uncapped Buffer)
		var capLine = showCap
			? `
                <div class="chartTooltipLine">
                    <div class="chartTooltipLine--label">Remaining Cap (Net):</div>
                    <div>${Highcharts.numberFormat(point.rmg_cap, 2)}% (${Highcharts.numberFormat(point.rmg_cap_net, 2)}%)</div>
                </div>
                <div class="chartTooltipLine">
                    <div class="chartTooltipLine--label">Reference Asset Return To Realize the Cap:</div>
                    <div>${Highcharts.numberFormat(point.asst_ret_realize_cap, 2)}%</div>
                </div>
            `
			: '';

		// Only show Remaining Buffer information in the chart tool tip if Buffer information exists(i.e.this is NOT an Enhanced Buffer)
		var buffLine = showBuffer
			? `
                <div class="chartTooltipLine">
                    <div class="chartTooltipLine--label">Remaining Buffer (Net):</div>
                    <div>${Highcharts.numberFormat(point.rmg_buffer, 2)}% (${Highcharts.numberFormat(point.rmg_buffer_net, 2)}%)</div>
                </div>
                <div class="chartTooltipLine">
                    <div class="chartTooltipLine--label">Downside Before Buffer (Net):</div>
                    <div>${Highcharts.numberFormat(point.rmg_downside_buffer, 2)}% (${Highcharts.numberFormat(point.rmg_downside_buffer_net, 2)}%)</div>
                </div>
                <div class="chartTooltipLine">
                    <div class="chartTooltipLine--label">Reference Asset To Buffer End:</div>
                    <div>${Highcharts.numberFormat(point.asst_buffer_end, 2)}%</div>
                </div>
            `
			: '';


		return `
            <div style="text-align: left;">As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}${asOfDateTime}</div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label"><strong>${series.name}</strong> Value/Return:</div>
                <div>$${Highcharts.numberFormat(point.fnd_value, 2)}/${Highcharts.numberFormat(y, 2)}%</div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label"><strong>${series.chart.series[1].name}</strong> Value/Return:</div>
                <div>$${Highcharts.numberFormat(point.asst_value, 2)}/${Highcharts.numberFormat(point.asst_ret, 2)}%</div>
            </div>
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label">Remaining Outcome Period:</div>
                <div>${point.rmg_outcome} days</div>
            </div>
            ${capLine}
            ${buffLine}
            <div class="chartTooltipLine">
                <div class="chartTooltipLine--label">Unrealized Option Payoff (Net):</div>
                <div>${Highcharts.numberFormat(point.unrealized_option_payoff, 2)}% (${Highcharts.numberFormat(point.unrealized_option_payoff_net, 2)}%)</div>
            </div>
        `;
	}
};

Exporting(Highcharts);
Accessibility(Highcharts);

window.Highcharts = Highcharts;
window.hcRenders = _hcRenders;